<template>
    <div>
        <Banner :banners="banners" show-overlay> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper default">
            <h2 class="title text-left d-flex">
                <img src="@/assets/news_ic_top.png" class="mr-2" alt="" /><span
                    class="align-self-end"
                    >最新消息</span
                >
            </h2>
            <p class="text-sm"></p>
            <div class="search-wrapper mb-3">
                <div class="d-flex">
                    <div class="input-group mr-1">
                        <input
                            type="text"
                            class="form-control"
                            v-model="paras.keyword"
                            @keyup.enter="query"
                            placeholder="請輸入關鍵字"
                        />
                        <div class="input-group-append">
                            <button class="btn btn-search" @click="query">
                                <img
                                    src="@/assets/common_ic_enter_search.png"
                                    alt="search"
                                />
                            </button>
                        </div>
                    </div>
                    <button class="btn btn-filter" @click="toggleSearchFilter">
                        <img
                            src="@/assets/common_ic_enter_filter.png"
                            alt="filter"
                        />
                    </button>
                </div>
                <div
                    class="search-filter"
                    ref="filter"
                    v-show="searchFilterShow"
                >
                    <ul class="row form-row m-0">
                        <li class="col-4">
                            <div
                                class="item"
                                :class="{
                                    active: paras.sources.includes(
                                        '臺中市政府-市政新聞',
                                    ),
                                }"
                                @click="
                                    toggleSourceFilter('臺中市政府-市政新聞')
                                "
                            >
                                臺中市政府-市政新聞
                            </div>
                        </li>
                        <li class="col-4">
                            <div
                                class="item"
                                :class="{
                                    active: paras.sources.includes(
                                        '臺中市政府水利局-最新消息',
                                    ),
                                }"
                                @click="
                                    toggleSourceFilter(
                                        '臺中市政府水利局-最新消息',
                                    )
                                "
                            >
                                臺中市政府水利局-最新消息
                            </div>
                        </li>
                        <li class="col-4">
                            <div
                                class="item"
                                :class="{
                                    active: paras.sources.includes(
                                        '臺中市觀光旅遊局-最新消息',
                                    ),
                                }"
                                @click="
                                    toggleSourceFilter(
                                        '臺中市觀光旅遊局-最新消息',
                                    )
                                "
                            >
                                臺中市觀光旅遊局-最新消息
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="result-total-text">
                共有{{ newsListFiltered.length }}項結果
            </div>

            <ul class="px-1 py-2" v-show="!newsLoading">
                <li v-for="news in newsListPagination" :key="news.id">
                    <a :href="news.Url" target="_blank">
                        <div class="news-item-wrapper">
                            <div class="title" v-text="news.name">
                                城市新風貌 柳川藍帶綠廊
                            </div>
                            <div class="d-flex">
                                <div
                                    class="time"
                                    v-text="
                                        dateConvert(
                                            news.startDate,
                                            'YYYY-MM-DD',
                                        )
                                    "
                                >
                                    2022-02-01
                                </div>
                                <div class="source" v-text="news.source">
                                    臺中市政府-市政新聞
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
            <Loader :show="newsLoading" class="px-1 py-2"></Loader>
            <Pagination
                :page-total="
                    Math.ceil(
                        this.newsListFiltered.length / this.pagination.pageSize,
                    )
                "
                :page-index="pagination.currentPage"
                @change-index="pagination.currentPage = $event"
            ></Pagination>
            <div class="fb-wrapper">
                <div class="title">
                    <img class="mr-2" src="@/assets/news_ic_fb.png" alt="fb" />
                    <h3>粉絲專頁</h3>
                    <div class="text-sm">加入粉絲專頁隨時掌握最新消息</div>
                </div>
                <ul class="row form-row">
                    <li class="col-6">
                        <a
                            href="https://www.facebook.com/GLAT.Taichung/"
                            target="_blank"
                            class="item"
                        >
                            <div>
                                <img
                                    src="@/assets/news_img_fb1.png"
                                    alt="漾台中FB"
                                />
                            </div>
                            <div class="title">
                                漾台中FB
                            </div>
                        </a>
                    </li>
                    <li class="col-6">
                        <a
                            href="https://www.facebook.com/waterresourcetaichung/"
                            target="_blank"
                            class="item"
                        >
                            <div>
                                <img
                                    src="@/assets/news_img_fb2.png"
                                    alt="水利大臺中FB"
                                />
                            </div>
                            <div class="title">
                                水利大臺中FB
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import { mapState } from 'vuex';
import $ from 'jquery';
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import Loader from '@/components/Loader';
import coreMixin from '@/js/mixin/coreMixin';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/banner_news.jpg'),
                },
            ],
            searchFilterShow: false,
            paras: {
                sources: [],
                keyword: '',
            },
            searchFilter: {
                keyword: '',
            },
        };
    },
    mounted() {},
    computed: {
        ...mapState('dataList', ['newsList', 'newsLoading']),
        newsListFiltered() {
            return this.newsList.filter(
                (news) => (!this.paras.sources.length
                        || this.paras.sources.includes(news.source))
                    && (!this.searchFilter.keyword
                        || news.name.match(this.searchFilter.keyword)),
            );
        },
        newsListPagination() {
            const nList = [];
            for (
                let i = 0;
                i < this.newsListFiltered.length / this.pagination.pageSize;
                // eslint-disable-next-line no-plusplus
                i++
            ) {
                nList.push(
                    this.newsListFiltered.slice(
                        i * this.pagination.pageSize,
                        (i + 1) * this.pagination.pageSize,
                    ),
                );
            }
            return nList[this.pagination.currentPage - 1];
        },
    },
    methods: {
        toggleSourceFilter(source) {
            if (this.paras.sources.includes(source)) {
                this.paras.sources.splice(
                    this.paras.sources.indexOf(source),
                    1,
                );
            } else {
                this.paras.sources.push(source);
            }
        },
        toggleSearchFilter() {
            this.searchFilterShow = !this.searchFilterShow;
            setTimeout(() => {
                if (this.searchFilterShow) {
                    document.addEventListener(
                        'click',
                        this.toggleSearchFilterHandle,
                    );
                } else {
                    document.removeEventListener(
                        'click',
                        this.toggleSearchFilterHandle,
                    );
                }
            }, 0);
            this.$nextTick(() => {});
        },
        toggleSearchFilterHandle(e) {
            if (
                e.target !== this.$refs.filter
                && !$(this.$refs.filter).has(e.target).length
            ) {
                this.searchFilterShow = false;
                document.removeEventListener(
                    'click',
                    this.toggleSearchFilterHandle,
                );
            }
        },
        query() {
            this.searchFilter.keyword = this.paras.keyword;
        },
    },
    components: {
        Banner,
        Breadcrumb,
        Loader,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
